import React, { useState } from "react";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import SubmitCancelBtn from "../../../common/SubmitCancelBtn";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import ApplicationUtil from "../../../../utils/ApplicationUtil";
import { postUserQuizResponse } from "../../../../apis/programService";
import DialogBox from "../../../common/DialogBox";
import Snackbar from "../../../common/Snackbar";

function QuizComponent({
  classes,
  viewDate,
  perDayViewData,
  programChallengeId,
  openQuiz,
  setOpenQuiz,
  setQuizOptions,
  quizOptions,
}) {
  const quizQuestion = perDayViewData?.programChallengeQuiz;
  const [selectedOption, setSelectedOption] = useState(null);
  const [onWrongResponse, setOnWrongResponse] = useState(false);
  const [disabledOptions, setDisabledOptions] = useState([]);

  if (!quizQuestion) return null;

  const handleSubmit = async () => {
    if (selectedOption === null) return;

    const runnerData = ApplicationUtil.getRunnerDetails();
    const runnerId = runnerData?.runnerId;

    const params = {
      viewDate,
      quizId: perDayViewData?.programChallengeQuiz?.id,
      optionId: selectedOption,
      runnerId,
      challengeId: programChallengeId,
    };

    try {
      const response = await postUserQuizResponse(params);

      if (response?.data?.isCorrect === true) {
        setOpenQuiz(false);
        Snackbar.show({
          variant: "success",
          isAutoHide: true,
          preventDuplicate: true,
          message: "Congratulations Correct Answer",
        });
      } else if (response?.data?.isCorrect === false) {
        setOnWrongResponse(true);
        const updatedOptions = response?.data?.options || [];
        if (updatedOptions.length > 0) {
          setQuizOptions(updatedOptions);
        }
      }

      if (response?.data?.error) {
        Snackbar.show({
          variant: "error",
          isAutoHide: true,
          preventDuplicate: true,
          message: response?.data?.error,
        });
      }
    } catch (error) {
      console.error("Failed to submit quiz response:", error);
    }
  };

  const renderWrongResponse = (
    <>
      <div className={classes.wrong_res_container}>
        <Typography variant="h6" style={{ fontWeight: 600 }}>
          "Oh no! That's not the correct answer."
        </Typography>
        <Typography variant="subtitle1">
          But hey, don't worry-you still have another shot!
        </Typography>
        <div className={classes.submitStyle}>
          <SubmitCancelBtn
            label="Try again"
            type="submit"
            onClick={() => {
              setOpenQuiz(true);
              setOnWrongResponse(false);
              setSelectedOption(null); // Reset selection
            }}
            style={{ borderRadius: "10px", width: "fit-content" }}
          />
        </div>
      </div>
    </>
  );
  return (
    <>
      <div className={classes.que_container}>
        <div className="questionBox">{quizQuestion.quiz}</div>

        <div>
          <FormControl component="fieldset">
            <RadioGroup
              name="quizOption"
              value={selectedOption}
              onChange={(e) => setSelectedOption(Number(e.target.value))}
            >
              {quizOptions.map((opt) => (
                <FormControlLabel
                  key={opt.id}
                  value={opt.id}
                  control={
                    <Radio
                      color="primary"
                      size="small"
                      className={classes.radioStyle}
                    />
                  }
                  label={opt.option}
                  className={classes.labelStyling}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </div>
        <div className={classes.submitStyle}>
          <SubmitCancelBtn
            label="Submit"
            type="submit"
            onClick={handleSubmit}
            style={{ borderRadius: "10px", width: "fit-content" }}
          />
        </div>
      </div>

      <div className={classes.attemptLeft}>
        <Typography variant="subtitle2">
          No. of attempts left : {quizOptions.length}
        </Typography>
      </div>

      {/* <DialogBox
        open={openSuccess}
        header={"Success"}
        message={renderCorrectResponse}
        dialogContentTextStyle={{ margin: 0 }}
        maxWidth={"sm"}
        closeDialog={() => {
          setOpenSuccess(false);
          setOpenQuiz(false)
        }}
        disableCloseBtn={true}
      /> */}
      <DialogBox
        open={onWrongResponse}
        header={"Oops !!"}
        message={renderWrongResponse}
        dialogContentTextStyle={{ margin: 0 }}
        maxWidth={"sm"}
        // closeDialog={() => {
        //    setOnWrongResponse(false);
        // }}
        disableCloseBtn={true}
      />
    </>
  );
}

const styles = (theme) => ({
  que_container: {
    // margin: "20px",
    borderRadius: "15px",
    padding: "20px 20px 0px 20px",
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    "& .questionBox": {
      color: "black",
      fontWeight: "600",
      fontSize: "18px",
      "& .formControlLabel": {},
      [theme.breakpoints.down("sm")]: {
        fontSize: "16px",
      },
    },
  },
  wrong_res_container: {
    borderRadius: "15px",
    padding: "20px 20px 5px 20px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  formControl: {
    margin: theme.spacing(1),
    width: "100%",
    margin: "auto",
    [theme.breakpoints.down("xs")]: {
      marginLeft: "-8px",
    },
  },
  radioStyling: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "row",
    },
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
      justifyContent: "space-evenly",
      flexWrap: "nowrap",
      // flexDirection: "column",
    },
  },
  radioStyle: {
    [theme.breakpoints.down("sm")]: {
      padding: 0,
      marginLeft: "13px",
      paddingLeft: "5px",
      marginRight: "2px",
    },
  },
  labelStyling: {
    "& .MuiTypography-body1": {
      fontSize: "22px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "18px",
      },
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "-11px",
      marginRight: 0,
      padding: 0,
      marginTop: "15px",
    },
  },
  submitStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  attemptLeft: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "5px"
  },
});

export default compose(withStyles(styles), withRouter)(QuizComponent);
